import React from "react";
import STOPP_data from "../json/STOPP.json";

function STOPP({ drug }) {
  const filteredResults = STOPP_data.filter((row) => {
    const drugName = row["Drug name "].toLowerCase().trim();
    const targetDrugName = drug.toLowerCase().trim();
    return (
      drugName.startsWith(targetDrugName) || drugName.endsWith(targetDrugName)
    );
  });

  return (
    <div>
      {filteredResults.length > 0 ? (
        filteredResults.map((result, index) => (
          <div key={index} className="flex table-cell">
            {drug.trim().length < result["Drug name "].trim().length && <p>For Drug: {result["Drug name "]}</p>}
            <div className="bullet-points">•</div>
            <div> {result["STOP Recommendation"]}</div>
          </div>
        ))
      ) : (
        <p>No results found</p>
      )}
    </div>
  );
}

export default STOPP;
